<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 货源信息管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-table
                :data="listDemands"
                border
                class="table"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="content" label="发布信息内容"></el-table-column>
				<el-table-column prop="createTimeStr" label="发布日期"></el-table-column>
				<el-table-column prop="nickName" label="发布人"></el-table-column>
				<el-table-column prop="isValidStr" label="状态" align="center">
					<template slot-scope="scope">
						 <span v-if="scope.row.isValid == 1">
							 有效
						 </span>
						 <span v-else style="color: red;">
							 已下架
						 </span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100" align="center">
				    <template slot-scope="scope">
						<el-button
						    type="text"
						    icon="el-icon-view"
						    @click="DemandsSee(scope.row)"
						>查看</el-button>
				        <!-- <el-button
				            type="text"
				            @click="DemandsDelete(scope.row)"
				        >下架</el-button> -->
				    </template>
				</el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
        <!-- 查看弹框 -->
        <el-dialog class="branch-dialog" title="查看货源信息" :visible.sync="seeDemandsVisible" width="600px">
        	<p class="branch-dialog-title">
        		货源信息维护
        	</p>
        	<div class="livingsee">
        		<p>姓名: <span>{{seeDemandscon.nickName}}</span></p>
        		<p>发布时间: <span>{{seeDemandscon.createTimeStr}}</span></p>
        		<p>
					{{seeDemandscon.content}}
				</p>
				<ul class="living-img">
					<li v-for="item in seeDemandscon.pictures">
						<img :src="'/api/static'+item" alt="">
					</li>
				</ul>
				<el-button v-if="seeDemandscon.isValid == 1" type="primary"  @click="DemandsDelete(seeDemandscon,2)">下架</el-button>
				<el-button v-else type="primary"  @click="DemandsDelete(seeDemandscon,1)">上架</el-button>
        	</div>
        	
            
        </el-dialog>
    </div>
</template>




<script>
import { listLivingDemands,deleteLivingDemand} from '@/api/index';// 导入我们的api接口
export default {
    name: 'livingdemands',
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,
            listDemands: [],  //列表数据
			seeDemandscon:[],   //查看内容
			
			seeDemandsVisible:false,
			
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistLivingDemands();
    },
    methods: {
		// 列表数据
		getlistLivingDemands(){
			listLivingDemands({
				current: this.query.pageIndex,                    
				size: this.query.pageSize               
			}).then(res => {
				// 获取数据成功后的其他操作
				this.listDemands = res.data.records;
				this.pageTotal = res.data.total;
			});
		},
		// 查看操作
		DemandsSee(row){
			  this.seeDemandsVisible = true; 
			  this.seeDemandscon = row;
			  if(typeof this.seeDemandscon.pictures=='string'){
				  this.seeDemandscon.pictures = this.seeDemandscon.pictures.split(',');
			  }
			  
		},
       
        // 删除操作
        DemandsDelete(row,type) {
			// if(row.isValid == 1){
				this.$confirm('确认继续操作吗？', '提示', {
					type: 'warning'
				}).then(() => {
					deleteLivingDemand({
						livingDemandId:row.livingDemandId,
						type:type
					}).then(res => {
						this.query.pageIndex = 1;
						this.getlistLivingDemands();
						this.seeDemandsVisible = false; 
						if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
						}else if(res.code == 1){
							  this.$message({
								message: res.message,
								type: 'warning'
							  });
						}else{
							  this.$message({
								message: '报错啦!',
								type: 'warning'
							  });
						}
						
					});
				}).catch(() => {});
			// }else{
			// 	this.$message({
			// 		message: '该信息已下架!',
			// 		type: 'warning'
			// 	});
			// }
			
			
           
        },
       
    
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistLivingDemands();
        }
    }
};
</script>

<style scoped>
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}

.livingsee p{
	/* height: 32px; */
	line-height: 32px;
	letter-spacing: 1px;
	font-size: 16px;
}
.livingsee .el-button{
	width: 100px;
	margin-top: 30px;
}
.living-img {
	display: flex;
	display: -webkit-flex;
	flex-wrap: wrap;
	padding: 0;
	margin: 0;
	list-style: none;
}
.living-img li{
	width:256px;
	height: 144px;
	margin-top: 20px;
}
.living-img li:nth-child(2n){
	margin-left: 10px;
}
.living-img li img{
	width: 100%;
	height: 100%;
}
</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	width: 100px;
}
.branch-dialog .el-form-item__content{
	margin-left: 100px;
}
/* .branch-area .el-form-item__content{
	margin-top: 30px;
} */
.branch-area{
	text-align: right;
}
.branch-area i{
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem {
	position: relative;
	margin-top: 10px;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.select-box .el-select {
	width: 100%;
}
</style>
